<template>
  <div v-editable="blok" class="fill-current" :class="marginClasses">
    <RichTextRenderer :document="blok.body" />
  </div>
</template>

<script setup lang="ts">
import type { MarginKey } from '~/storyblok/types/storyblok'
import type { SbBannerText } from '~/storyblok/types/storyblok.gen'

const props = defineProps({
  blok: {
    type: Object as PropType<SbBannerText & { margin_top?: MarginKey }>,
    required: true,
  },
})

const { marginClasses } = useStoryblokMargins(props.blok)
</script>
